import {
  type LayoutSkeleton,
  layoutSkeletonSchema,
} from '../../composables/data-fetching/auto-layout/index.types'

import { useConfigStore } from './useConfigStore'

/**
 * Pinia store for managing the layout skeleton
 * This store fetches the layout skeleton from a remote CDN and provides methods to refresh it
 * It also handles loading state and provides a reactive reference to the layout skeleton
 */
export const useLayoutSkeletonStore = useConfigStore<
  LayoutSkeleton | undefined
>({
  configStoreKey: 'layoutSkeleton',
  defaults: undefined,
  schema: (data) => layoutSkeletonSchema.parse(data),
})
